import "./BrandLockup.css";

import { useTenantStore } from "../../stores/tenant/use-tenant-store";

type BrandLockupProps = {
  logoClassName?: string;
  className?: string;
  onLogoClick?: () => void;
};

const BrandLockup = ({ logoClassName, className, onLogoClick }: BrandLockupProps) => {
  const { assets } = useTenantStore();

  return (
    <div className={`brand-lockup ${className ?? ""}`}>
      <img src={assets.logo.image} alt={assets.logo.alt} className={logoClassName} onClick={onLogoClick} />
      {assets.coBrand && <img src={assets.coBrand.image} alt={assets.coBrand.alt} className="brand-lockup-cobrand" />}
    </div>
  );
};

export default BrandLockup;
